import React, { FC } from "react";
import Img from "gatsby-image";
import styled, { keyframes } from "styled-components";

type PodImgProps = {
  image: any;
};

const CircleWave = styled.div`
  position: relative;
  justify-content: center;
  display: flex;
  width: 100%;

  .request-loader {
    top: 50%;
    width: 30%;
    border-radius: 50%;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  }
`;

const PodImg: FC<PodImgProps> = ({ image }) => {
  return (
    <div className="song-container">
      <CircleWave>
        <Img className="request-loader" alt={image} fluid={image} />
      </CircleWave>


      {/*<h2>{currentSong.name}</h2>*/}
      {/*<h3>{currentSong.artist}</h3>*/}
    </div>
  );
};
export default PodImg;
